import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomActions } from "@midland-industries/Store/Reducers";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<CustomActions>;

type HandlerType = Handler<{ packingBasis?: string }, Props>;

export const DispatchSetPackingBasis: HandlerType = props => {
    const packingBasis = props.parameter.packingBasis ?? "";
    props.dispatch({
        type: "CustomData/CheckoutReviewAndSubmit/SetPackingBasis",
        packingBasis,
    });
};

export const chain = [DispatchSetPackingBasis];

const setPackingBasis = createHandlerChainRunner(chain, "setPackingBasis");
export default setPackingBasis;
